import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../App';
import './index.css';
import './i18n';

const rootElement = document.getElementById('root');

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});
if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
